import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Szma301aRequest, Szma301aResponse, SZMA301AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSzma301aService {
  /** 契約情報取得（ガス）結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Szma301aResponse>();

  /**
  * 契約情報取得（ガス）結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSzma301aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZMA301AService} SZMA301AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSzma301aService
   */
  constructor(
    private sZMA301AService: SZMA301AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * 契約情報取得（ガス）API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Szma301Response>}
   * @memberof UsedSgkb122dSzma301aService
   */
  searchContractor(value: Szma301aRequest): Observable<Szma301aResponse> {
    // 検索条件を保存
    return this.sZMA301AService.c13RSZMA301APost(<Szma301aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SZMA301A);
          return throwError(err.message);
        })
      );
  }
}
